import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import { GetActionBg }        from '../../../../actions/scopoAction';
import TopoPag                from '../../../../container/RenderTopoPag';
import bg_batalha             from "../../../../img/bg/bg_batalha.png";
import BatalhajogoIncio       from './batalha_jogo_inicio';
import BatalhaJogoFim         from './batalha_jogo_fim';
import { GetByQuestoesDuelo } from '../../../../actions/questaoActions';
import '../../../../css/aluno/batalha/batalha.css';
import '../../../../css/aluno/batalha/batalha-alternative.css';
import '../../../../css/aluno/batalha/batalha-card.css';



class Batalhar_Jogo extends Component {

    constructor(props){

        super(props);
        this.state = {

          usu_id : this.props.session.id,
          due_id : this.props.match.params.id,
          load   : false,
          acao   : ""
        };     
  }

    componentWillMount(){

        this.props.GetByQuestoesDuelo(this.state.usu_id,this.state.due_id).then((response)=>{
            this.setState({load:true});

            console.log(response.payload.data);
            this.renderComponets(response.payload.data.statusDuelo);
        });  

       this.props.GetActionBg(bg_batalha);
    }

    renderComponets(val){
  
        const obj = {}  
                switch (val) {
                  case 0:
                    obj.acao = <BatalhajogoIncio/>;
                  break;
                  case 1:
                     obj.acao = <BatalhaJogoFim/>;
                  break;
                  case 2:
                     obj.acao = <BatalhaJogoFim/>;
                  break;
                  default:
                 
                 // obj.acao =  "Componente não foi carregado";
                  break;
                }
              this.setState({acao: obj.acao})
      }
    
    render() {
        return (
            <div className="hud-middle-center active">
                <TopoPag titulo="BATALHA" />
                <main className="hud-middle-center-content">
                ( <div>{this.state.acao}</div> )
                </main>
            </div>  
        );
    }
}

function mapStateToProps(state) {

    return { 
            session     : state.auth.session,
            actionModal : state.scopoReducer.actionModal,
            menu        : state.configReducer.menu,
           }
}

export default connect(mapStateToProps, { GetActionBg,GetByQuestoesDuelo })(Batalhar_Jogo);



// WEBPACK FOOTER //
// ./src/components/aluno/batalha/jogo/batalhar_jogo.js